/**
 * 根据业务逻辑格式化米粒价值。
 * 目前，它将该值除以10并保留一位小数。
 *
 * @param credits 来自API的原始米粒值。
 * @returns 格式化后的米粒值。如果输入不是有效数字，则返回0。
 */
export const formatCredits = (credits: number | null | undefined): number => {
  const value = Number(credits);
  if (isNaN(value)) {
    return 0;
  }
  // .toFixed(1) 返回字符串，所以需要用 Number() 转换回数字
  return Number((value / 10).toFixed(1));
};

/**
 * 专门处理文本创作消耗的格式化函数。
 * 将该值除以10，不进行四舍五入。
 *
 * @param credits 来自API的原始米粒值。
 * @returns 格式化后的米粒值，直接除以10。如果输入不是有效数字，则返回0。
 */
export const formatTextCredits = (credits: number | null | undefined): number => {
  const value = Number(credits);
  if (isNaN(value)) return 0;

  // 这里表达式可以更直观地写成 value / 10
  const result = value / 10;

  // 截断小数点后 5 位（不四舍五入）
  const res = toFixedFloor(result, 5);

  // console.log(`formatTextCredits: ${value} -> ${result} -> ${res}`);
  return res;
};

function toFixedFloor(num: number, decimalPlaces: number): number {
  if (!isFinite(num)) return num; // 非有限数直接返回

  const factor = Math.pow(10, decimalPlaces);
  const scaled = num * factor;

  // 缩放后的浮点误差按数值大小比例产生，用一个与之成比例的小偏移来修正
  const delta = Math.min(1, Number.EPSILON * Math.abs(scaled) * 10);
  const adjusted = scaled + (num >= 0 ? delta : -delta);

  return Math.trunc(adjusted) / factor;
}
